<template>
    <div class="row">
        <div class="col-12 col-lg-8">
            <div>
                <template v-if="event?.place?.tipo_proceso_online === 3">
                    <EntradaResumenItem
                        v-for="(entrada, index) in entradas"
                        :key="'proc3-'+index+reloadComponents"
                        :index="index"
                        :entrada="entrada"
                        :subtitulo="event.reserva_instalaciones ? event.fecha_sesion : null"
                        :documentacionComprador="datos?.tipoDocumentoSeleccionado"
                        :loading="loading"
                        @handleSeguro="handleSeguro"
                    >
                        <template #ubicacion>
                            <span v-if="entrada.sector_name">Sector: {{ entrada.sector_name }} - </span>
                            <template v-if="!event?.reserva_instalaciones">
                                {{ $t('general.fila') }}: {{ entrada.fila }} - {{ $t('general.butaca') }}: {{ entrada.butaca }}
                            </template>
                            <template v-else>{{ entrada.name }}</template>
                        </template>
                        <template #extra>
                            <div v-if="entrada.visibilidad_reducida" class="tw:mb-2">
                                <span class="tw:text-red-600 tw:font-bold tw:text-xs oswald tw:uppercase">
                                    {{ $t('visibilidad_reducida.nombre') }}
                                    <template v-if="entrada.porcentaje_visibilidad">: {{ entrada.porcentaje_visibilidad }}%</template>
                                </span>
                            </div>
                        </template>
                    </EntradaResumenItem>
                </template>
                <template v-else>
                    <template v-if="entradas?.length">
                        <EntradaResumenItem
                            v-for="(entrada, index) in entradas"
                            :key="'std-'+index+reloadComponents"
                            :index="index"
                            :entrada="entrada"
                            :subtitulo="event?.reserva_instalaciones ? event.fecha_sesion : null"
                            :documentacionComprador="datos?.tipoDocumentoSeleccionado"
                            :loading="loading"
                            @handleSeguro="handleSeguro"
                        >
                            <template #ubicacion>
                                {{ entrada.asiento ? entrada.asiento.zona_nombre : entrada.zona_nombre }}
                                <span v-if="entrada.asiento?.fila > 0" class="tw:md:ml-15 tw:ml-4">
                                    {{ $t('general.fila') }}: {{ entrada.asiento.fila }} - {{ $t('general.butaca') }}: {{ entrada.asiento.asiento }}
                                </span>
                            </template>
                        </EntradaResumenItem>
                    </template>
                    <template v-if="preciosPlazas?.length">
                        <EntradaResumenItem
                            v-for="(entrada, index) in preciosPlazas"
                            :key="'plaza-'+index+reloadComponents"
                            :index="index"
                            :entrada="entrada"
                            :subtitulo="event?.reserva_instalaciones ? event.fecha_sesion : null"
                            :documentacionComprador="datos?.tipoDocumentoSeleccionado"
                            :loading="loading"
                            @handleSeguro="handleSeguro"
                        >
                            <template #ubicacion>
                                <template v-if="sectores">Selección en Sector</template>
                                <template v-else-if="!event?.reserva_instalaciones">
                                    <template v-if="entrada.fila">
                                        Fila: {{ entrada.fila }} - Asiento: {{ entrada.butaca }}
                                    </template>
                                    <template v-else>
                                        {{ getButacaName(entrada) }}
                                    </template>
                                </template>
                                <template v-else>{{ entrada.name }}</template>
                            </template>
                        </EntradaResumenItem>
                    </template>
                </template>

                <!-- Desglose multi-precio (reservas con varios tipos de entrada) -->
                <template v-if="es_reserva_multi_precio">
                    <ul
                        v-for="linea in lineas_multi_precio"
                        :key="'mp-' + linea.precio_id"
                        class="resumen d-md-flex"
                    >
                        <li class="altcolor-content">
                            <div class="text-bold oswald text-uppercase m-0 w-100">
                                {{ $t('evento.entradas') }}
                            </div>
                        </li>
                        <li class="tw:flex-grow">
                            <div class="h5 text-bold oswald text-uppercase m-0 w-100">
                                {{ linea.nombre }}
                            </div>
                        </li>
                        <li>
                            <div class="tw:text-xs tw:text-gray-500 oswald tw:uppercase m-0 w-100">
                                {{ linea.precio_unitario | formatear_precio }} x {{ linea.cantidad }}
                            </div>
                        </li>
                        <li>
                            <div class="h5 text-bold oswald text-uppercase m-0 w-100">
                                {{ linea.subtotal | formatear_precio }}
                            </div>
                        </li>
                    </ul>
                </template>

                <!-- Desglose de unidades genéricas (reservas sin recinto, precio único) -->
                <template v-if="es_reserva_unidades">
                    <ul class="resumen d-md-flex">
                        <li class="altcolor-content">
                            <div class="text-bold oswald text-uppercase m-0 w-100">
                                {{ $t('evento.entradas') }}
                            </div>
                        </li>
                        <li class="tw:flex-grow">
                            <div class="h5 text-bold oswald text-uppercase m-0 w-100">
                                {{ $tc('evento.desglose_unidades', cantidad_solicitada, { cantidad: cantidad_solicitada, total: unidades_reserva_total }) }}
                            </div>
                        </li>
                        <li>
                            <div class="tw:text-xs tw:text-gray-500 oswald tw:uppercase m-0 w-100">
                                {{ $t('general.precio') }}: {{ precio_unitario_reserva | formatear_precio }} x {{ cantidad_solicitada }}
                            </div>
                        </li>
                        <li>
                            <div class="h5 text-bold oswald text-uppercase m-0 w-100">
                                {{ subtotal_reserva_unidades | formatear_precio }}
                            </div>
                        </li>
                    </ul>
                </template>

                <template v-if="voucher">
                    <ul class="resumen d-md-flex">
                        <li class="altcolor-content">
                            <div class="text-bold oswald text-uppercase m-0 w-100">
                                {{ es_reserva ? $t('evento.discount') : $t("evento.voucher") }}
                            </div>
                        </li>
                        <li>
                            <div class="h5 text-bold oswald text-uppercase m-0 w-100">
                                {{ es_reserva ? $t('evento.discount') : $t("evento.voucher") }} -
                                {{ voucher.discount_percent != 0 ? voucher.discount_percent + "%" : voucher.discount_fixed + "€" }}
                            </div>
                        </li>
                        <li>
                            <div class="h5 text-bold oswald text-uppercase m-0 w-100">
                                {{ $t("evento.code") }}: {{ voucher.code }}
                            </div>
                        </li>
                        <li>
                            <div class="h5 text-bold oswald text-uppercase m-0 w-100">
                                {{ -voucher_discounted_total | formatear_precio }}
                            </div>
                        </li>

                    </ul>
                </template>

                <ResumenProductos v-if="productos && productos.length > 0" :productos="productos"/>

                <div class="mb-5">
                    <label>{{ $t('evento.total_pagar') }}</label>
                    <div class="price price-large gradient-color" data-cy="precio-total">
                        {{ total_price | formatear_precio }}
                    </div>
                </div>
            </div>
        </div>
        <div v-if="mostrarBloqueDescuento" class="col-12 col-lg-8">
            <slot name="afterSummary"></slot>
        </div>

        <div class="col-12 col-lg-8 mt-4">
            <FormTerminos
                :error="error"
                @continuar="aceptarCondiciones"
                :desactivar="desactivar"
            />
        </div>
        <b-col cols="12">
            <ResumenPrecioComponent
                :key="gastos"
                :price="precio_base_resumen"
                :price_management="gastos"
                :price_management_interno="price_management_interno_resumen"
                :iva="event != undefined && event.experiencia ? footer.iva_experiencia : footer.iva_partido"
            />
        </b-col>
        <div class="col-12 mt-4 d-flex">
            <Button
                v-if="total_price > 0"
                id="resumen-continuar"
                type="button"
                :label="$t('partido.continuar')"
                :disabled="loading || desactivar || procesar_pago"
                custom-class="compra-responsive"
                @click="terminar"
            />
            <Button
                v-else
                type="button"
                :label="$t('evento.descargar_entradas')"
                :disabled="loading || desactivar"
                @click="terminar"
            />
            <Button
                type="button"
                :label="$t('formularios.atras')"
                :disabled="loading || desactivar"
                custom-class="ml-2 compra-responsive"
                @click="volver()"
            />
            <template v-if="form" >
                <div id="formulario-compra" v-html="form" v-show="false">
                </div>
            </template>

        </div>
    </div>
</template>

<script setup>
    import { ref, computed } from 'vue';
    import { getCurrentInstance } from 'vue';
    import { useResumenPricing } from '@/composables/front/reservas/useResumenPricing';

    import FormTerminos from '@/components/frontend/components/FormTerminos';
    import ResumenPrecioComponent from '@/components/frontend/compra/components/ResumenPrecioComponent.vue';
    import ResumenProductos from './components/productos/ResumenProductos.vue';
    import Button from '@/modules/ui/Button.vue';
    import EntradaResumenItem from '@/modules/front/events/EntradaResumenItem.vue';
    import { useEventoTracking } from '@/composables/front/analytics/useEventoTracking';

    // ── PROPS ─────────────────────────────────────────────────────────────────────
    const props = defineProps({
        entradas: { type: Array, required: false, default: null },
        formulario: { type: String, required: false, default: null },
        productos: { type: Array, required: false, default: null },
        voucher: { type: Object, required: false, default: null },
        event: { type: Object, required: true },
        datos: { type: Object, required: false, default: null },
        session_id: { type: [Number, String], required: false, default: null },
        entradasPlazas: { type: Array, required: false, default: null },
        desactivar: { type: Boolean, required: false, default: false },
        sectores: { type: [Array, Object], required: false, default: null },
        cantidad_solicitada: { type: Number, required: false, default: null },
        cantidades_por_precio: { type: Array, required: false, default: null },
        precios_reserva: { type: Array, required: false, default: null },
        units_total: { type: Number, required: false, default: null },
    });

    // ── EMITS ─────────────────────────────────────────────────────────────────────
    const emit = defineEmits(['terminar', 'terminado', 'volver']);

    // ── VUE 2.7 INSTANCE ─────────────────────────────────────────────────────────
    const instance = getCurrentInstance();
    const vm = instance.proxy;

    // ── ESTADO LOCAL ──────────────────────────────────────────────────────────────
    const noTieneTelefono = ref(false);
    const error = ref(false);
    const terminos = ref(false);
    const loading = ref(false);
    const procesar_pago = ref(false);
    const isValidNumber = ref(!!props.datos?.telefono);
    const localDatos = ref(props.datos);
    const segurosSeleccionados = ref([]);
    const formularioConSeguro = ref(null);
    const reloadComponents = ref(0);

    // ── COMPOSABLE DE PRECIOS ─────────────────────────────────────────────────────
    // unitsTotalRef: computed derivado de la prop units_total (pasada desde Reservas.vue
    // a través de useReservaFlow → unitsTotal). Para otros usos del componente donde
    // units_total no se pasa, el composable lo recibe como null y devuelve 0 de forma segura.
    const unitsTotalRef = computed(() => props.units_total ?? null);
    const {
        es_reserva_unidades,
        es_reserva_multi_precio,
        lineas_multi_precio,
        subtotal_multi_precio,
        precio_unitario_reserva,
        unidades_reserva_total,
        subtotal_reserva_unidades,
        preciosPlazas,
        total,
        total_con_gd,
        total_gd,
        totalPlazas,
        totalPlazas_gd,
        totalPlazas_con_gd,
        gastos,
        totalSeguros,
        price_management_interno_resumen,
        voucher_discounted_total,
        total_price,
        precio_base_resumen,
    } = useResumenPricing(
        props,
        calcularTotalProductos,
        calcularTotalProductosSinManagement,
        segurosSeleccionados,
        unitsTotalRef
    );

    // ── COMPUTED SIMPLES ──────────────────────────────────────────────────────────

    const es_reserva = computed(() => window.location.href.includes('reservas'));

    /**
     * Visibilidad del bloque `afterSummary`, que en el flujo de eventos es el
     * input del código de descuento.
     *
     * `total` sólo suma butacas, así que una compra de plazas (zonas sin butaca
     * numerada del recinto anexo) llegaba con `entradas` vacío y `total = 0`: el
     * input no se renderizaba aunque sí hubiese importe que descontar. Su base
     * vive en `totalPlazas`, que es la que hay que mirar en ese modo.
     *
     * Los modos de reserva (`es_reserva_unidades` / `es_reserva_multi_precio`)
     * mantienen su guarda original sobre `total_price`.
     */
    const mostrarBloqueDescuento = computed(() =>
        total.value > 0 ||
        totalPlazas.value > 0 ||
        (es_reserva_unidades.value && total_price.value > 0) ||
        (es_reserva_multi_precio.value && total_price.value > 0)
    );

    const footer = computed(() => vm.$store.getters.getFooter);

    const hayEntradasAseguradas = computed(() =>
        segurosSeleccionados.value?.filter(s => s.seguro).length > 0
    );

    /** Formulario de pago: con seguro tiene prioridad sobre el original. */
    const form = computed(() => formularioConSeguro.value ?? props.formulario);

    // ── MÉTODOS DE CÁLCULO ────────────────────────────────────────────────────────

    function calcularTotalProductos() {
        if (!props.productos || props.productos.length === 0) return 0;
        return props.productos.reduce((acc, producto) => {
            const priceManagement = producto.item.price_management_interno === 0
                ? Number(producto.item.price_management)
                : 0;
            return acc + (producto.item.price * producto.units) + (priceManagement * producto.units);
        }, 0);
    }

    function calcularTotalProductosSinManagement() {
        if (!props.productos || props.productos.length === 0) return 0;
        return props.productos.reduce((acc, producto) => {
            return acc + (producto.item.price * producto.units);
        }, 0);
    }

    // ── MÉTODOS DE INTERACCIÓN ────────────────────────────────────────────────────

    function terminar() {
        loading.value = true;
        if (terminos.value === true && !noTieneTelefono.value) {
            trackPaymentInfo();
            guardarTerminosCondiciones();
            emit('terminar', props.datos);
            if (props.formulario) {
                setTimeout(() => {
                    const form = document.querySelector('#formulario-compra form');
                    if (form) form.submit();
                }, 500);
            } else if (total_price.value === 0) {
                emit('terminado', true);
            } else {
                procesar_pago.value = true;
                emit('terminado');
            }
        } else {
            loading.value = false;
            error.value = true;
        }
    }

    function guardarDatos() {
        if (!isNaN(localDatos.value.telefono) && localDatos.value.telefono) {
            emit('terminar', null, localDatos.value);
            noTieneTelefono.value = false;
        } else {
            noTieneTelefono.value = true;
        }
    }

    function aceptarCondiciones(continuar, privacidad, condiciones, comunicaciones) {
        localDatos.value.privacidad = privacidad;
        localDatos.value.condiciones = condiciones;
        localDatos.value.comunicaciones = comunicaciones;
        terminos.value = continuar === true;
    }

    function guardarTerminosCondiciones() {
        const params = {
            filters: {},
            privacidad: props.datos.privacidad,
            condiciones: props.datos.condiciones,
            comunicaciones: props.datos.comunicaciones,
            session_id: props.session_id,
        };
        vm.$store.dispatch(vm.config.getVuexAlias('front.guardar.terminos.condiciones'), params)
            .catch(() => {
                vm.$toast.error('Error al guardar los terminos y condiciones');
            });
    }

    async function volver() {
        await actualizarSeguros();
        emit('volver');
    }

    function getButacaName(plaza) {
        if (!plaza.butaca) {
            return `${vm.$t('general.butaca')}: ${plaza.name}`;
        }
        const nButaca = plaza.butaca;
        const nFila = plaza.fila;
        const sector = plaza.sector_name;
        let name = '';
        if (sector) {
            name += `${vm.$t('general.sector')}: ${sector} - `;
        }
        return name += `${vm.$t('general.fila')}: ${nFila} - ${vm.$t('general.butaca')}: ${nButaca}`;
    }

    function handleValidNumber(isValid) {
        isValidNumber.value = isValid;
        if (isValid) {
            guardarDatos();
        }
    }

    function trackPaymentInfo() {
        try {
            const { trackAddPaymentInfo } = useEventoTracking({
                store: vm.$store,
                getVuexAlias: vm.config.getVuexAlias,
            });

            const eventoResumen = {
                evento_id: props.event?.id,
                evento_name: props.event?.nombre || props.event?.name,
                total_price: total_price.value,
                datos_compradores: (props.entradas || []).map(entrada => ({
                    precio: entrada.precio?.precio || 0,
                })),
                productos: props.productos || [],
            };

            trackAddPaymentInfo(eventoResumen);
        } catch (trackingError) {
            console.error('[GA4] add_payment_info failed:', trackingError);
        }
    }

    async function handleSeguro({ cart_item_id, seguro, importe }) {
        loading.value = true;
        const index = segurosSeleccionados.value.findIndex(s => s.cart_item_id === cart_item_id);

        if (seguro) {
            if (index === -1) {
                segurosSeleccionados.value.push({ cart_item_id, seguro: true, importe });
            } else {
                segurosSeleccionados.value[index].seguro = true;
            }
        } else {
            if (index !== -1) {
                segurosSeleccionados.value[index].seguro = false;
            }
        }

        const payload = {
            session_id: props.session_id,
            cart_items: segurosSeleccionados.value,
        };

        try {
            await vm.$store.dispatch(vm.config.getVuexAlias('front.actualizar.seguro'), payload)
                .then(res => {
                    formularioConSeguro.value = res.data.formulario ? res.data.formulario : null;
                });
        } catch (err) {
            vm.$toast.error(err.response?.data?.message || 'Error al actualizar el seguro de las entradas');
        } finally {
            loading.value = false;
        }
    }

    async function actualizarSeguros() {
        const aseguradas = segurosSeleccionados.value
            .filter(s => s.seguro === true)
            .map(s => ({ cart_item_id: s.cart_item_id, seguro: false }));

        if (aseguradas.length > 0) {
            try {
                loading.value = true;
                const params = {
                    session_id: props.session_id,
                    cart_items: aseguradas,
                };
                await vm.$store.dispatch(vm.config.getVuexAlias('front.actualizar.seguro'), params)
                    .then(res => {
                        segurosSeleccionados.value = segurosSeleccionados.value.map(s => ({
                        ...s,
                        seguro: false,
                        }));
                        formularioConSeguro.value = res.data.formulario ? res.data.formulario : null;
                        reloadComponents.value++;
                    });
            } catch (err) {
                vm.$toast.error(err?.response?.data?.message || 'Error al desactivar los seguros');
            } finally {
                loading.value = false;
            }
        }
    }
</script>
